import axios from 'axios';

// token ที่ได้จากการ login (authService.setSession เก็บไว้ที่ key นี้)
export const TOKEN_KEY = 'accessToken';

// host ของ API เรา — ส่ง token ไปเฉพาะที่นี่ ไม่ให้หลุดไป service ภายนอก
const API_HOSTS = ['localhost', '127.0.0.1', 'kpattgroup.com', 'www.kpattgroup.com'];

export function getAccessToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

function isOwnApi(config) {
  const url = config.url || '';
  // path แบบ relative ต่อกับ baseURL หรือ origin ของหน้าเว็บ
  const base = config.baseURL || window.location.origin;

  try {
    const { hostname } = new URL(url, base);
    return hostname === window.location.hostname || API_HOSTS.indexOf(hostname) !== -1;
  } catch (e) {
    return false;
  }
}

/** ใส่ Authorization: Bearer <token> ให้ทุก request ของ axios instance นี้ */
export function attachAuthToken(instance) {
  instance.interceptors.request.use((config) => {
    const token = getAccessToken();
    const headers = config.headers || {};

    // ถ้าผู้เรียกกำหนด Authorization มาเองแล้ว ไม่ทับ
    if (token && !headers.Authorization && isOwnApi(config)) {
      headers.Authorization = `Bearer ${token}`;
    }

    return { ...config, headers };
  });

  return instance;
}

// หน้าที่ import axios ตรง ๆ (ไม่ผ่าน instance) ก็ได้ token ด้วย
attachAuthToken(axios);
